import React from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../../store/store";
import { isKnownNonManagerRole } from "../../Utils/membershipRoleUtils";
import MembershipAccessDenied from "./MembershipAccessDenied";

interface MembershipRoleGateProps {
  children: React.ReactElement;
}

const MembershipRoleGate: React.FC<MembershipRoleGateProps> = ({
  children
}) => {
  const role = useSelector((state: RootState) => state.user.userDetails?.role);

  // Do not hard-block when role is unavailable in the MFE store.
  // Manager access is allowlisted in membershipRoleUtils: any other non-empty role
  // string is treated as non-manager (including new/renamed API roles until added there).
  if (isKnownNonManagerRole(role)) {
    return <MembershipAccessDenied />;
  }

  return children;
};

export default MembershipRoleGate;
